import { render, staticRenderFns } from "./user-review.vue?vue&type=template&id=6b7b8094&"
import script from "./user-review.vue?vue&type=script&lang=js&"
export * from "./user-review.vue?vue&type=script&lang=js&"
import style0 from "./user-review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports